module.exports = {"title":"Renouvelez votre véhicule et recevez un {voucher} d’une valeur pouvant atteindre"}